/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAccountInfo.defs'
export { main as default } from './getAccountInfo.defs'
